
function setProspectsHeight() {
    const prospectsSections = document.querySelectorAll(".prospects");

    prospectsSections.forEach(section => {
      const content = section.querySelector(".prospects__content");
      const imageBlock = section.querySelector(".prospects__image");

      if (content && imageBlock) {
        if (window.innerWidth > 991) {
          const contentHeight = content.offsetHeight;
          imageBlock.style.height = contentHeight + "px";
        } else {
          imageBlock.style.height = "auto"; 
        }
      }
    });
}

setProspectsHeight();

window.addEventListener("resize", setProspectsHeight);

